import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** Motor % load = A_meas / FLA — clamp meter on lead, bar gauge of % load, nameplate. */
export function DiagramMotorFLA() {
  return (
    <DiagramCanvas>
      {/* Supply lines */}
      {[105, 125, 145].map((yp, i) => (
        <G key={i}>
          <Line x1={20} y1={yp} x2={120} y2={yp} stroke={DT.stroke} strokeWidth="2" />
          <SvgText x={14} y={yp + 3} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="end">L{i + 1}</SvgText>
        </G>
      ))}

      {/* Clamp ammeter */}
      <Circle cx={70} cy={125} r={14} fill="none" stroke={DT.varColor} strokeWidth="1.6" />
      <Path d="M58,123 A14,14 0 0 0 82,127" fill="none" stroke={DT.varColor} strokeWidth="1.6" />
      <Rect x={56} y={138} width={28} height={20} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.2" rx="2" />
      <SvgText x={70} y={152} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">A</SvgText>

      {/* Motor body */}
      <Rect x={120} y={85} width={120} height={85} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" rx="6" />
      {Array.from({ length: 7 }).map((_, i) => (
        <Line key={i} x1={120} y1={89 + i * 12} x2={240} y2={89 + i * 12}
          stroke={DT.stroke} strokeWidth="0.4" opacity={0.4} />
      ))}
      {/* Nameplate */}
      <Rect x={134} y={100} width={64} height={42} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.2" rx="2" />
      <SvgText x={166} y={113} fill={DT.desc} fontSize="7" fontFamily={DT.mono} textAnchor="middle">NAMEPLATE</SvgText>
      <SvgText x={166} y={125} fill={DT.varColor} fontSize="8.5" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">FLA = xx</SvgText>
      <SvgText x={166} y={136} fill={DT.varColor} fontSize="8.5" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">HP / V / Hz</SvgText>

      {/* Shaft */}
      <Line x1={240} y1={128} x2={290} y2={128} stroke={DT.stroke} strokeWidth="5" />

      {/* % Load bar gauge (right) */}
      <Rect x={260} y={45} width={70} height={30} fill={DT.fill} stroke={DT.stroke} strokeWidth="1" rx="2" />
      <SvgText x={295} y={56} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="middle">% LOAD</SvgText>
      {/* Bar */}
      <Rect x={264} y={62} width={62} height={8} fill={DT.fill} stroke={DT.stroke} strokeWidth="0.8" />
      <Rect x={264} y={62} width={48} height={8} fill={DT.varColor} opacity={0.85} />
      <SvgText x={295} y={84} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">~78%</SvgText>

      {/* Service factor band */}
      <Line x1={264 + 56} y1={60} x2={264 + 56} y2={72} stroke={DT.dim} strokeWidth="0.8" strokeDasharray="2,2" />
      <SvgText x={264 + 56} y={94} fill={DT.dim} fontSize="7" fontFamily={DT.mono} textAnchor="middle">SF</SvgText>

      {/* Labels */}
      <LeaderLine x1={70} y1={138} x2={20} y2={210} varName="A_meas" desc="clamp reading" anchor="start" />
      <LeaderLine x1={166} y1={123} x2={120} y2={210} varName="FLA" desc="nameplate amps" anchor="middle" />
      <LeaderLine x1={295} y1={66} x2={310} y2={210} varName="% Load" desc="A_meas / FLA" anchor="end" />

      <FormulaTag formula="% Load = (A_meas / FLA) · 100   (linear above 50% load)" />
    </DiagramCanvas>
  );
}
